import Autocomplete from "autocomplete.js";

/** @typedef { import('./Autocomplete').AutocompleteDataset } AutocompleteDataset */

/**
 * @abstract
 */
class Dadata {
    /**
     * @param {HTMLElement} node
     */
    constructor(node) {
        if (!node)
            throw new ReferenceError('Dadata constructor requres one argument of type `HTMLElement`');

        const isNodeDadata = node.classList.contains('dadata') && node.tagName === 'INPUT';

        if (!isNodeDadata)
            throw new Error('Dadata isn\'t found');

        const url = node.dataset['url'];

        if (!url)
            throw new Error('Dadata has no `data-url` attribute');

        /** @type {HTMLInputElement} */
        this.dadataNode = node;
        /** @type {string} */
        this.dadataUrl = url;

        this.sourceOptions = {
            debounce: 250,
            cache: true
        }

        this.autocompleteOptions = {
            autoselect: true,
            autoselectOnBlur: true,
            hint: false,
            tabAutocomplete: true,
            minLength: 3
        }
    }

    /**
     * @returns {AutocompleteInstance}
     */
    initializeAutocomplete() {
        const source = this.getSource();

        return new Autocomplete(this.dadataNode, this.autocompleteOptions, [source]);
    }

    /**
     * @abstract
     * @returns {AutocompleteDataset}
     */
    getSource() {
    }
}

export default Dadata;
